(function () {
	'use strict';

	angular.module('MiscellaneousSettingsModule').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('miscellaneous-settings', {
			url: '/miscellaneous',
			parent: 'target-project',
			abstract: true,
		});

		$stateProvider.state('new-export-template-list', {
			url: '/export/list',
			parent: 'miscellaneous-settings',
			data: {
				admin: true,
				access: '*',
				title: 'Liste Template Export',
			},
			views: {
				'@miscellaneous-settings': {
					template: `<app-export-template-list></app-export-template-list>`,
				},
			},
		});

		$stateProvider.state('export-template-list', {
			url: '/export',
			parent: 'miscellaneous-settings',
			data: {
				admin: true,
				access: '*',
				title: 'Liste Template Export',
			},
			resolve: {
				isList: () => true,
			},
			views: {
				'@miscellaneous-settings': {
					component: 'exportTemplateListCmp',
				},
			},
		});

		$stateProvider.state('export-template-edit', {
			url: '/export/:exportConfigId',
			parent: 'miscellaneous-settings',
			data: {
				admin: true,
				access: '*',
				title: 'Template Export',
			},
			views: {
				'@miscellaneous-settings': {
					template: `<app-export-template
						ng-prop-export_config_id="$ctrl.exportConfigId">
						</app-export-template>`,
					controller: [
						'$stateParams',
						function ($stateParams) {
							const $ctrl = this;
							init();
							function init() {
								const exportId = parseInt($stateParams['exportConfigId'], 10);
								$ctrl.exportConfigId = !Number.isNaN(exportId)
									? exportId
									: null;
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('metadata', {
			url: '/metadata',
			parent: 'miscellaneous-settings',
			data: {
				admin: true,
				access: '*',
				title: 'Metadata',
			},
			views: {
				'@miscellaneous-settings': {
					templateUrl: './src/components/modules/metadata/metadatas.html',
					controller: 'MetadataController',
				},
			},
		});
		$stateProvider.state('new-metadata', {
			url: '/metadata/list',
			parent: 'miscellaneous-settings',
			data: {
				admin: true,
				access: 'member',
				title: 'Metadata',
			},
			views: {
				'@miscellaneous-settings': {
					template: `<app-metadata-list></app-metadata-list>`,
				},
			},
		});

		$stateProvider.state('formulas-usage', {
			url: '/formulas/usage',
			parent: 'miscellaneous-settings',
			data: {
				admin: true,
				access: '*',
				title: 'Usage Formule',
			},
			views: {
				'@miscellaneous-settings': {
					template: `<app-formulas-usage-list ng-prop-project_label="$ctrl.projectLabel"></app-formulas-usage-list>`,
					controller: [
						'AppSelectorService',
						function (AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('new-formulas-catalog', {
			url: '/formula-catalog/list',
			parent: 'target-project',
			data: {
				admin: true,
				access: '*',
				title: 'Catalogues des Formules',
			},
			views: {
				'@target-project': {
					template: `<app-formula-list></app-formula-list>`,
				},
			},
		});

		$stateProvider.state('formulas-catalog', {
			url: '/formula-catalog',
			parent: 'target-project',
			data: {
				admin: true,
				access: '*',
				title: 'Catalogues des Formules',
			},
			views: {
				'@target-project': {
					templateUrl:
						'./src/components/modules/formulas-catalog/formulas-catalog.html',
					controller: 'FormulasCatalogController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('deprec-rankings', {
			url: '/rankings',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Classements',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/ranking/rankings.html',
					controller: 'RankingListController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('rankings', {
			url: '/rankings/list',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Classements',
			},
			views: {
				'@target-project': {
					template: `<app-ranking-list ng-prop-project_label="$ctrl.projectLabel"></app-ranking-list>`,
					controller: [
						'AppSelectorService',
						function (AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('rankings-new', {
			url: '/rankings/new',
			parent: 'target-project',
			data: {
				admin: true,
				access: '*',
				title: 'Nouveau Classement',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/ranking/ranking-form.html',
					controller: 'RankingEditController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('rankings-edit', {
			url: '/rankings/edit/:rankingId',
			parent: 'target-project',
			data: {
				admin: true,
				access: '*',
				title: 'Edition du Classement',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/ranking/ranking-form.html',
					controller: 'RankingEditController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('dataBlockExportHistory', {
			url: '/datablocks-export-history',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Historique des exports',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/export-history/history.html',
					controller: 'ExportHistoryController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('dc-graph', {
			url: '/dc-graph',
			parent: 'target-project',
			data: {
				admin: false,
				access: 'member',
				title: 'HD-Graphique',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/graph/dcGraph.html',
					controller: 'DcGraphController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('trace-parent', {
			url: '/traces',
			parent: 'target-project',
			abstract: true,
		});

		$stateProvider.state('traces', {
			url: '',
			parent: 'trace-parent',
			data: {
				admin: false,
				access: '*',
				title: 'Traces',
			},
			views: {
				'@trace-parent': {
					templateUrl: './src/components/modules/trace/traces.html',
					controller: 'TracesController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('new-traces', {
			url: '/list?limit?page',
			parent: 'trace-parent',
			data: {
				admin: false,
				access: 'member',
				title: 'Traces',
			},
			views: {
				'@trace-parent': {
					template: `<app-trace-list ng-prop-limit="$ctrl.limit"
											ng-prop-page="$ctrl.page"></app-trace-list>`,
					controller: [
						'$stateParams',
						'AppSelectorService',
						function ($stateParams, AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								const limit = parseInt($stateParams['limit'], 10);
								const page = parseInt($stateParams['page'], 10);

								$ctrl.limit = !Number.isNaN(limit)
									? [20, 50, 100].reduce((prev, curr) => {
											return Math.abs(curr - limit) < Math.abs(prev - limit)
												? curr
												: prev;
									  })
									: 20;
								$ctrl.page = !Number.isNaN(page) ? page : 1;
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('importDb', {
			url: '/import-db',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Import base de données',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/import-db/import-db.html',
					controller: 'ImportDbController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('link-graph', {
			url: '/link-graph?node=:nodeId',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Graphe complet',
			},
			params: { nodeId: { dynamic: true } },
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/graph/linkGraph.html',
					controller: 'LinkGraphController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('path-graph', {
			url: '/path-graph',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Graphe Fonctionnel',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/graph/pathGraph.html',
					controller: 'PathGraphController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('value-search', {
			url: '/value-search',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Recherche de valeurs',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/value-search/search.html',
					controller: 'valueSearchController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('pictogrammes', {
			url: '/pictogrammes',
			parent: 'target-project',
			data: {
				admin: true,
				access: 'member',
				title: 'Pictogrammes',
			},
			views: {
				'@target-project': {
					templateUrl: './src/components/modules/pictogrammes/pictogrammes.html',
					controller: 'PictogrammeController',
					controllerAs: '$ctrl',
				},
			},
		});
	}
})();
